import { render, staticRenderFns } from "./InvoiceDetailsHeader.vue?vue&type=template&id=4246ddd8"
import script from "./InvoiceDetailsHeader.vue?vue&type=script&lang=js"
export * from "./InvoiceDetailsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports